import { render, staticRenderFns } from "./KnowledgeDetailThai.vue?vue&type=template&id=074250f8&"
import script from "./KnowledgeDetailThai.vue?vue&type=script&lang=js&"
export * from "./KnowledgeDetailThai.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeDetailThai.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports